"use strict";

import {loadParsley} from "@elements/parsley-bootstrap-validation";

export function initInScope ($scope) {

    $scope.find('.js-new-account-form__btn').on('click', function (e) {
        let $this = $(this),
            $newAccountForm = $this.closest('.js-new-account-form');

        $newAccountForm.find(':input').prop('required', true);
        $newAccountForm.find('.form-group').removeClass('hide-validation');
    });

    $scope.find('.js-new-account-form__reset').on('click', function (e) {
        let $newAccountForm = $scope.find('.js-new-account-form');

        $newAccountForm.find(':input').prop('required', false);
        $newAccountForm.find('.form-group').addClass('hide-validation');

    });
}